import Api from '../../http'
import * as Types from './type'

export const queryDictionary = async (params: Types.DictionaryQueryListReq) => {
  const res = await Api.admin.post<Types.DictionaryQueryListRes>('/api/dictionary_query/list', params)
  return res.data
}

export const queryProviderList = async (params?: Types.ProviderListRequest) => {
  const res = await Api.admin.post<Types.ProviderListRes>('/api/provider/list', params)
  return res.data
}

interface providerLogoRespVos {
  /**服务商编码 */
  providerCode?: string
  /**服务商名称 */
  providerName?: string
  /**服务商logo地址 */
  logoUrl?: string
}

/**
 * 服务商字典配置查询
 * @returns
 */
export const queryProviderDictionary = () => Api.admin.post<{ providerLogoRespVos: providerLogoRespVos[] }>('/api/provider/logo/list?_sw_cache=15')

/**
 * oneship优化0728需求，订单列表筛选条件-服务商，运单列表筛选条件-承运商，需展示ONESHIP发货地区支持的全部物流服务商
 * 这两个地方的数据新开了一个接口加载
 */
export const queryEfficientProvider = (data?: { logisticsType: string }) =>
  Api.admin.post<{ providerLogoRespVos: providerLogoRespVos[] }>('/api/provider/oneship/list', data, { params: { ...data, _sw_cache: 15 } })
